import PublicPageRenderer from '@/components/builder/PublicPageRenderer';
import { ContactPopup } from '@/components/ContactPopup';
import { SEO, LOCAL_BUSINESS_SCHEMA, FAQ_SCHEMA, WEBSITE_SCHEMA } from '@/components/SEO';
import { useState } from 'react';

export default function Home() {
  const [contactPopup, setContactPopup] = useState(false);

  return (
    <div data-testid="home-page">
      <SEO
        url="/"
        jsonLd={[LOCAL_BUSINESS_SCHEMA, FAQ_SCHEMA, WEBSITE_SCHEMA]}
      />
      <PublicPageRenderer slug="home" />
      <ContactPopup open={contactPopup} onOpenChange={setContactPopup} />
    </div>
  );
}
